var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_4144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.342 17.5253C17.7672 16.5984 18.4152 16.0325 19.3781 15.4386C20.5586 14.7934 21.3449 13.6437 21.6447 12.3788C22.0116 10.8303 21.7484 9.19958 20.913 7.84522C20.0775 6.49087 18.7383 5.52386 17.1899 5.15694C15.6415 4.79001 14.0107 5.05322 12.6563 5.88866C11.302 6.7241 10.335 8.06334 9.96806 9.61175C9.73748 10.5848 9.65539 11.7986 10.6206 13.3633C11.1403 14.2059 11.5397 15.1226 11.5037 16.1418M10.5814 20.034L16.4197 21.4175M10.6321 24.1568L14.5243 25.0792",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_4144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5.97656 0.443848) rotate(13.3314)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.94afc8dfa8c18dbadf9afa252335a363.svg";
export { ForwardRef as ReactComponent };